var _path, _path2;

var _excluded = ["svgRef"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgEmployeeAdd = function SvgEmployeeAdd(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 32,
    viewBox: "0 0 35 32",
    ref: svgRef
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.001 26.35l-3.095-5.417 1.036-2.766c0.644-0.471 1.35-1.334 1.477-1.461 0.155-0.154 0.363-0.24 0.579-0.237 4.051-0.051 7.378 3.264 7.437 7.41-0.020 1.379-1.124 2.483-2.472 2.471h-4.962zM15.189 18.838l-0.81 2.095 2.616 5.381 0.738 1.434-3.846 4.252-4.371-4.241 0.607-1.444 2.252-5.381-1.018-2.105c0.777 0.178 1.579 0.229 2.388 0.139 0.496 0.020 0.972-0.027 1.443-0.129zM9.165 17.87l1.698 3.063-2.764 5.417h-5.611c-0.65 0.011-1.277-0.244-1.744-0.707s-0.734-1.097-0.743-1.762c0.058-4.146 3.385-7.462 7.437-7.41 0.216-0.003 0.425 0.082 0.579 0.237 0.114 0.114 0.634 0.727 1.148 1.162zM12.665 17.567c-3.947 0-7.157-3.943-7.157-8.783-0.028-2.229 0.691-4.4 2.037-6.146 1.229-1.637 3.113-2.607 5.12-2.638 3.949 0 7.161 3.94 7.161 8.783s-3.214 8.784-7.161 8.784z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.826 10.522h4.957v3.304h-4.957v4.957h-3.304v-4.957h-4.957v-3.304h4.957v-4.957h3.304v4.957z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgEmployeeAdd, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/employee-add.0177be22.svg";
export { ForwardRef as ReactComponent };